import { axios } from '@ori/axios';
import { isBeautyApp } from '@ori/beauty-app-info';
import type { PickClientAppDataConfigProps } from '@ori/client-app-config';
import { handleResponse, validateStatus } from '@ori/fetching';
import { getClientQueryParam } from '@ori/presentation-utils';
import type { StaticLocalizationsSingleLanguageLocalizationsDtoLocalizations } from '@ori/static-api-client-react';
import browserUpdate from 'browser-update';
import Cookies from 'js-cookie';

import {
  defaultTranslations,
  optionsWithoutTranslations,
  SHOULD_BE_CLOSED_COOKIE,
  TEST_OUTDATED_BROWSER_INFO_QUERY_PARAM,
  translationsNamespace,
} from '../constants';
import '../index.css';
import { parseLocalizations } from './parseLocalizations';

export type AppProps = PickClientAppDataConfigProps<'currentLanguage' | 'tenant' | 'staticApiUrl'>;

export const outdatedBrowserInfo = ({ currentLanguage, staticApiUrl, tenant }: AppProps): void => {
  if (isBeautyApp() || Cookies.get(SHOULD_BE_CLOSED_COOKIE)) {
    return;
  }
  const test = getClientQueryParam(TEST_OUTDATED_BROWSER_INFO_QUERY_PARAM) === 'true';

  axios<{ Localizations: StaticLocalizationsSingleLanguageLocalizationsDtoLocalizations }>(
    `/tenants/${tenant}/localizations/${translationsNamespace}`,
    {
      baseURL: staticApiUrl,
      method: 'GET',
      params: { lang: currentLanguage },
      validateStatus,
    },
  )
    .then((response) => {
      const localizations = handleResponse(response, {
        onSuccess: ({ data }) => parseLocalizations(data.Localizations),
        onError: () => defaultTranslations,
      });

      browserUpdate({
        ...optionsWithoutTranslations,
        test,
        text: {
          msg: localizations.yourBrowserIsOutdated,
          msgmore: localizations.updateYourBrowser,
          bupdate: localizations.update.toUpperCase(),
        },
      });
    })
    .catch((error) => {
      console.warn('Cannot start outdated browser info', { error: error as Error });
    });
};
